<template>
  <div class="about">
    <div class="title">
      <span>{{ $t('about.title') }}</span>
    </div>
    <section>
      <p>
        {{ $t('about.p1') }}
      </p>
      <p>
        {{ $t('about.p2') }}
      </p>
      <p>
        {{ $t('about.p3') }}
      </p>
      <p>
        {{ $t('about.p4') }}
      </p>
    </section>

    <section>
      <p>
        {{ $t('about.p5') }}
        <span @click="copyemail()" class="us_email">easynote_ai@hotmail.com</span>
      </p>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      language: localStorage.getItem('language') || 'en', // 从 localStorage 获取语言，默认为英文
    };
  },
  methods: {
    copyemail() {
      let text = document.querySelector(".us_email").innerText;
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.value = text;
      input.select();
      document.execCommand("Copy");
      input.remove();
      this.$message.success("Email has been copied to your clipboard");
    },
  },
};
</script>
<style lang="less" scoped>
.about {
  margin: 0 auto;
  font-family: Arial, sans-serif;
  color: #fff;
  position: relative;
  z-index: 10; //背景图影响点击按钮
  width: 80%;
  max-width: 1000px;
  min-height: 580px;
  padding: 20px;
  
  section {
    opacity: 0.8; //文字透明度
  }

  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    margin-top: 40px;
    margin-bottom: 40px;
    
    span {
      background: rgba(255, 255, 255, 0.9);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-size: 32px;
      font-weight: bold;
    }
  }

  p {
    margin-bottom: 20px;
    line-height: 1.6;
    font-size: 16px;
  }

  .us_email {
    text-decoration: underline;
    cursor: pointer;
    color: #a855f7;
  }
  
  /* 媒体查询：平板设备 */
  @media (max-width: 768px) {
    width: 90%;
    padding: 15px;
    
    .title {
      height: 70px;
      margin-top: 30px;
      margin-bottom: 30px;
      
      span {
        font-size: 28px;
      }
    }
    
    p {
      font-size: 15px;
      margin-bottom: 18px;
    }
  }
  
  /* 媒体查询：移动设备 */
  @media (max-width: 480px) {
    width: 95%;
    padding: 10px;
    min-height: auto;
    
    .title {
      height: 60px;
      margin-top: 20px;
      margin-bottom: 25px;
      
      span {
        font-size: 24px;
      }
    }
    
    p {
      font-size: 14px;
      margin-bottom: 16px;
    }
  }
}
</style>
